import { fromTable } from '@/integrations/supabase/db';
import { SearchResult, SearchSectionId } from '../types';
import { getMatchFunction, getServerPattern, getServerLimit, calculateRelevanceScore } from '../utils';

export async function searchVertriebspartner(
  term: string, 
  limit: number, 
  exactMatch: boolean,
  fuzzyMatch: boolean = false,
  signal?: AbortSignal
): Promise<SearchResult[]> {
  if (!term.trim()) return [];
  
  const pattern = getServerPattern(term, fuzzyMatch);
  const serverLimit = getServerLimit(limit, fuzzyMatch);
  const matchFn = getMatchFunction(exactMatch, fuzzyMatch);
  
  const { data, error } = await fromTable('vertriebspartner')
    .select('id, vorname, zuname, email, mobiltelefon, verguetungsschema, company, updated_at')
    .or(`vorname.ilike.${pattern},zuname.ilike.${pattern},email.ilike.${pattern},company.ilike.${pattern}`)
    .limit(serverLimit);

  if (error) {
    console.error('Vertriebspartner search error:', error);
    return [];
  }

  return (data || [])
    .filter(vp => matchFn(term, vp.vorname, vp.zuname, vp.email, vp.mobiltelefon, vp.company))
    .slice(0, limit)
    .map(vp => {
      const title = `${vp.vorname || ''} ${vp.zuname || ''}`.trim() || vp.company || 'Unbenannt';
      const subtitle = vp.email || vp.mobiltelefon || undefined;
      
      return {
        id: vp.id,
        type: 'vertriebspartner' as SearchSectionId,
        title,
        subtitle,
        badge: vp.verguetungsschema || 'Partner',
        data: vp,
        relevanceScore: calculateRelevanceScore(term, title, subtitle, vp.updated_at)
      };
    });
}
